"use strict";
(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[47292],{

/***/ 15022:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(59126);





var About = function(param) {
    var data = param.data;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                size: "16px",
                weight: "bold",
                children: "Tentang Obligasi FR"
            }),
            data.map(function(item, idx) {
                return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_styled__WEBPACK_IMPORTED_MODULE_4__/* .AboutItemContainer */ .Wt, {
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                align: "center",
                                justify: "center",
                                style: {
                                    width: 16,
                                    height: 16
                                },
                                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                    src: "/icon/fr/checkmark.svg"
                                })
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                ml: "12px",
                                children: item
                            })
                        ]
                    })
                }, "fr-about-item-".concat(idx + 1));
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (About);


/***/ }),

/***/ 52068:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(579);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(42298);
/* harmony import */ var date_fns__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(23855);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(59126);







var CouponDetail = function(props) {
    var annualRate = props.annualRate, couponDistribution = props.couponDistribution, dueDate = props.dueDate, issuedDate = props.issuedDate, minimumOrder = props.minimumOrder, nextDate = props.nextDate, issuer = props.issuer;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.Fragment, {
        children: [
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .CouponDetailItemContainer */ ._e, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                src: "/icon/fr/coupon-rate.svg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                direction: "column",
                                ml: "12px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Tingkat Kupon / Tahun"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        weight: "bold",
                                        children: [
                                            annualRate,
                                            "%"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                src: "/icon/fr/coupon-due-date.svg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                direction: "column",
                                ml: "12px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Jatuh Tempo"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        weight: "bold",
                                        children: (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(dueDate), "dd MMM yyyy")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .CouponDetailItemContainer */ ._e, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                src: "/icon/fr/coupon-minimum-purchase.svg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                direction: "column",
                                ml: "12px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Minimum Pembelian"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        weight: "bold",
                                        children: [
                                            "1 Unit (Rp",
                                            numeral__WEBPACK_IMPORTED_MODULE_4___default()(minimumOrder).format("0,0"),
                                            ")"
                                        ]
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                src: "/icon/fr/coupon-next-date.svg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                direction: "column",
                                ml: "12px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Tanggal Kupon Berikutnya"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        weight: "bold",
                                        children: (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(nextDate), "dd MMM yyyy")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_5__/* .CouponDetailItemContainer */ ._e, {
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                src: "/icon/fr/coupon-period.svg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                direction: "column",
                                ml: "12px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Pembagian Kupon"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        weight: "bold",
                                        children: couponDistribution
                                    })
                                ]
                            })
                        ]
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        align: "center",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                                src: "/icon/fr/coupon-publication.svg"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                                direction: "column",
                                ml: "12px",
                                children: [
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        color: "#858585",
                                        mb: "4px",
                                        children: "Tanggal Penerbitan"
                                    }),
                                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                        weight: "bold",
                                        children: (0,date_fns__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)((0,date_fns__WEBPACK_IMPORTED_MODULE_7__/* ["default"] */ .Z)(issuedDate), "dd MMM yyyy")
                                    })
                                ]
                            })
                        ]
                    })
                ]
            }),
            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                align: "center",
                mt: "16px",
                mb: "16px",
                children: [
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                        src: "/icon/fr/coupon-publisher.svg"
                    }),
                    /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                        direction: "column",
                        ml: "12px",
                        children: [
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                color: "#858585",
                                mb: "4px",
                                children: "Penerbit"
                            }),
                            /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z, {
                                weight: "bold",
                                children: issuer
                            })
                        ]
                    })
                ]
            })
        ]
    });
};
/* harmony default export */ __webpack_exports__["Z"] = (CouponDetail);


/***/ }),

/***/ 59126:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "H0": function() { return /* binding */ ContentContainerLeft; },
/* harmony export */   "Jh": function() { return /* binding */ MyInvestmentMenuButton; },
/* harmony export */   "Mj": function() { return /* binding */ MyInvestmentMenuDropdown; },
/* harmony export */   "Mv": function() { return /* binding */ DetailContainer; },
/* harmony export */   "OO": function() { return /* binding */ ContentContainer; },
/* harmony export */   "Wt": function() { return /* binding */ AboutItemContainer; },
/* harmony export */   "_e": function() { return /* binding */ CouponDetailItemContainer; },
/* harmony export */   "c6": function() { return /* binding */ MyInvestmentContainer; },
/* harmony export */   "hq": function() { return /* binding */ MyInvestmentWrapper; },
/* harmony export */   "pD": function() { return /* binding */ ContentContainerRight; },
/* harmony export */   "zj": function() { return /* binding */ MyInvestmentItemContainer; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(19521);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(74575);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #FFFFFF;\n  border: 1px solid #DADADA;\n  border-radius: 4px;\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 10px;\n\n  @media ",
        " {\n    padding: 20px;\n  }\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #EBF8F3;\n  padding: 16px;\n  width: 100%;\n  border-radius: 4px;\n  justify-content: space-between;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: 10px;\n\n  #my-investment-symbol {\n    display: none;\n  }\n\n  .my-investment-item > div {\n    display: block;\n    p > {\n      margin-left: 0;\n    }\n  }\n\n  @media ",
        " {\n    gap: 32px;\n\n    #my-investment-symbol {\n      display: flex;\n    }\n\n    .my-investment-item > div {\n      display: flex;\n      p > {\n        margin-left: 8px;\n      }\n    }\n  }\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding: 16px;\n  border-top: 1px solid #DADADA;\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n\n  @media ",
        " {\n    padding: 20px;\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: grid;\n  grid-template-columns: repeat(1, minmax(0, 1fr));\n  justify-content: space-between;\n\n  @media ",
        " {\n    grid-template-columns: repeat(2, minmax(0, 1fr));\n  }\n\n  > div:first-child {\n    margin-bottom: 7px;\n\n    @media ",
        " {\n      margin-bottom: 0;\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}
function _templateObject6() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  padding-right: 0;\n  padding-left: 0;\n  border-right: unset;\n  \n\n  ",
        " {\n    padding-bottom: 12px;\n    padding-top: 12px;\n    border-bottom: 1px solid #EDEDED;\n\n    @media ",
        " {\n      padding-top: 16px;\n      padding-bottom: 16px;\n    }\n  }\n\n  @media ",
        " {\n    border-right: 1px solid #DADADA;\n    padding-left: 20px;\n    padding-right: 20px;\n  }\n"
    ]);
    _templateObject6 = function _templateObject6() {
        return data;
    };
    return data;
}
function _templateObject7() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        ""
    ]);
    _templateObject7 = function _templateObject7() {
        return data;
    };
    return data;
}
function _templateObject8() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  margin: 20px 0 0 0;\n\n  ",
        " {\n    padding: 12px 0 12px 0;\n    border-bottom: 1px solid #EDEDED;\n\n    :last-child {\n      border-bottom: unset;\n    }\n\n    @media ",
        " {\n      padding: 16px 0 16px 0;\n    }\n  }\n\n  @media ",
        " {\n    margin: 0 20px 0 20px;\n  }\n"
    ]);
    _templateObject8 = function _templateObject8() {
        return data;
    };
    return data;
}
function _templateObject9() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  cursor: pointer;\n"
    ]);
    _templateObject9 = function _templateObject9() {
        return data;
    };
    return data;
}
function _templateObject10() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #FFFFFF;\n  border-radius: 6px;\n  border: 1px solid #DADADA;\n  padding: 8px 16px;\n\n  > * {\n    cursor: pointer;\n  }\n"
    ]);
    _templateObject10 = function _templateObject10() {
        return data;
    };
    return data;
}



var DetailContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-0"
})(_templateObject());
var MyInvestmentWrapper = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-1"
})(_templateObject1(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var MyInvestmentContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).withConfig({
    componentId: "sc-bc9d857e-2"
})(_templateObject2());
var MyInvestmentItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    align: "center"
}).withConfig({
    componentId: "sc-bc9d857e-3"
})(_templateObject3(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var ContentContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-4"
})(_templateObject4(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var CouponDetailItemContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-5"
})(_templateObject5(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var ContentContainerLeft = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-6"
})(_templateObject6(), CouponDetailItemContainer, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var AboutItemContainer = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-7"
})(_templateObject7());
var ContentContainerRight = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-8"
})(_templateObject8(), AboutItemContainer, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_2__/* ["default"].tablet */ .Z.tablet);
var MyInvestmentMenuButton = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-9"
})(_templateObject9());
var MyInvestmentMenuDropdown = styled_components__WEBPACK_IMPORTED_MODULE_3__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-bc9d857e-10"
})(_templateObject10());


/***/ }),

/***/ 95186:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero_ChartHeader; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Text.js
var Text = __webpack_require__(95541);
// EXTERNAL MODULE: ./src/@deprecated-ui/common/Flex.js
var Flex = __webpack_require__(70821);
// EXTERNAL MODULE: ./src/features/company/Chart/ExpandButtonToggle.tsx
var ExpandButtonToggle = __webpack_require__(68068);
// EXTERNAL MODULE: ./src/features/company/Chart/TimeframeButtons.tsx
var TimeframeButtons = __webpack_require__(5856);
// EXTERNAL MODULE: ./node_modules/numeral/numeral.js
var numeral = __webpack_require__(92077);
var numeral_default = /*#__PURE__*/__webpack_require__.n(numeral);
// EXTERNAL MODULE: ./src/features/company/constants.ts
var constants = __webpack_require__(55564);
// EXTERNAL MODULE: ./src/@deprecated-ui/company/Radio.js
var Radio = __webpack_require__(89535);
// EXTERNAL MODULE: ./node_modules/lodash.debounce/index.js
var lodash_debounce = __webpack_require__(91296);
var lodash_debounce_default = /*#__PURE__*/__webpack_require__.n(lodash_debounce);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
;// CONCATENATED MODULE: ./src/features/company/FRPage/Hero/ChartTypeButtons.tsx







function ChartTypeButtons(param) {
    var showChartType = param.showChartType, chartType = param.chartType, onSelectChartType = param.onSelectChartType, className = param.className;
    var debouncedOnChange = (0,react.useCallback)(lodash_debounce_default()(function(e) {
        onSelectChartType(e.target.value);
    }, 0), [
        onSelectChartType
    ]);
    return showChartType ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Flex/* default */.Z, {
        className: className,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default.Group */.Z.Group, {
            value: chartType,
            onChange: debouncedOnChange,
            // @ts-expect-error
            type: "solid-primary",
            children: constants/* FR_CHART_TYPES.map */.hW.map(function(opt) {
                return /*#__PURE__*/ (0,jsx_runtime.jsx)(Radio/* default.Button */.Z.Button, {
                    value: opt.value,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                        className: "text",
                        height: "1.15",
                        padding: "2px 8px",
                        align: "center",
                        children: opt.label
                    })
                }, opt.value);
            })
        })
    }) : null;
}
/* harmony default export */ var Hero_ChartTypeButtons = (ChartTypeButtons);

// EXTERNAL MODULE: ./src/features/company/FRPage/Hero/styled.ts
var styled = __webpack_require__(81676);
;// CONCATENATED MODULE: ./src/features/company/FRPage/Hero/ChartHeader.tsx









function ChartHeader(param) {
    var timeframe = param.timeframe, chartType = param.chartType, isChartVisible = param.isChartVisible, priceInfo = param.priceInfo, onSelectTimeframe = param.onSelectTimeframe, onSelectChartType = param.onSelectChartType, onExpand = param.onExpand;
    var renderYield = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    weight: "bold",
                    children: [
                        numeral_default()(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.yield).format("0.00"),
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "#858585",
                    size: "12px",
                    pt: "3px",
                    children: "Yield"
                })
            ]
        });
    };
    var renderBuyPrice = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    weight: "bold",
                    children: [
                        numeral_default()(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.bidPrice).format("0.00"),
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "#858585",
                    size: "12px",
                    pt: "3px",
                    children: "Harga Beli"
                })
            ]
        });
    };
    var renderSellPrice = function() {
        /*#__PURE__*/ return (0,jsx_runtime.jsxs)(styled/* ChartSectionItem */.nJ, {
            children: [
                /*#__PURE__*/ (0,jsx_runtime.jsxs)(Text/* default */.Z, {
                    weight: "bold",
                    children: [
                        numeral_default()(priceInfo === null || priceInfo === void 0 ? void 0 : priceInfo.offerPrice).format("0.00"),
                        "%"
                    ]
                }),
                /*#__PURE__*/ (0,jsx_runtime.jsx)(Text/* default */.Z, {
                    color: "#858585",
                    size: "12px",
                    pt: "3px",
                    children: "Harga Jual"
                })
            ]
        });
    };
    var renderChartType = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_ChartTypeButtons, {
            chartType: chartType,
            onSelectChartType: onSelectChartType,
            showChartType: true
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(ExpandButtonToggle/* default */.Z, {
            onExpand: onExpand
        });
    };
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)("div", {
        children: [
            /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                justify: "space-between",
                style: {
                    background: "#FFFFFF"
                },
                // @ts-expect-error
                p: "20px",
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                        style: {
                            gap: 20
                        },
                        children: [
                            renderYield(),
                            renderBuyPrice(),
                            renderSellPrice()
                        ]
                    }),
                    renderExpandButtonToggle()
                ]
            }),
            isChartVisible && /*#__PURE__*/ (0,jsx_runtime.jsxs)(Flex/* default */.Z, {
                align: "center",
                justify: "space-between",
                style: {
                    background: "#FFFFFF"
                },
                // @ts-expect-error
                px: "20px",
                children: [
                    renderChartType(),
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TimeframeButtons/* default */.Z, {
                        showTimeframes: true,
                        timeframe: timeframe,
                        onSelectTimeframe: onSelectTimeframe,
                        timeFrameList: constants/* chartTimeframesFR */.rn
                    })
                ]
            })
        ]
    });
}
/* harmony default export */ var Hero_ChartHeader = (ChartHeader);


/***/ }),

/***/ 35985:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony import */ var _swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__ = __webpack_require__(47568);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(34051);
/* harmony import */ var _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default = /*#__PURE__*/__webpack_require__.n(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0__);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(85893);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(70821);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(92077);
/* harmony import */ var numeral__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(numeral__WEBPACK_IMPORTED_MODULE_4__);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(41664);
/* harmony import */ var next_link__WEBPACK_IMPORTED_MODULE_5___default = /*#__PURE__*/__webpack_require__.n(next_link__WEBPACK_IMPORTED_MODULE_5__);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(11163);
/* harmony import */ var next_router__WEBPACK_IMPORTED_MODULE_6___default = /*#__PURE__*/__webpack_require__.n(next_router__WEBPACK_IMPORTED_MODULE_6__);
/* harmony import */ var utils_general__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(42227);
/* harmony import */ var utils_clevertap__WEBPACK_IMPORTED_MODULE_8__ = __webpack_require__(48028);
/* harmony import */ var react__WEBPACK_IMPORTED_MODULE_9__ = __webpack_require__(67294);
/* harmony import */ var utils_company__WEBPACK_IMPORTED_MODULE_10__ = __webpack_require__(4168);
/* harmony import */ var antd__WEBPACK_IMPORTED_MODULE_21__ = __webpack_require__(56266);
/* harmony import */ var global_Moderation_Modals__WEBPACK_IMPORTED_MODULE_11__ = __webpack_require__(31359);
/* harmony import */ var features_company_constants__WEBPACK_IMPORTED_MODULE_12__ = __webpack_require__(55564);
/* harmony import */ var global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_22__ = __webpack_require__(29658);
/* harmony import */ var _tanstack_react_query__WEBPACK_IMPORTED_MODULE_18__ = __webpack_require__(36492);
/* harmony import */ var lib_api_watchlist__WEBPACK_IMPORTED_MODULE_13__ = __webpack_require__(15056);
/* harmony import */ var utils_errors__WEBPACK_IMPORTED_MODULE_20__ = __webpack_require__(66350);
/* harmony import */ var global_Image__WEBPACK_IMPORTED_MODULE_14__ = __webpack_require__(579);
/* harmony import */ var _Header_styled__WEBPACK_IMPORTED_MODULE_15__ = __webpack_require__(50489);
/* harmony import */ var _Header_FollowCompanyButton__WEBPACK_IMPORTED_MODULE_16__ = __webpack_require__(89238);
/* harmony import */ var _styled__WEBPACK_IMPORTED_MODULE_17__ = __webpack_require__(81676);























var cleanSymbol = utils_company__WEBPACK_IMPORTED_MODULE_10__/* ["default"].cleanSymbol */ .Z.cleanSymbol, isReksaDana = utils_company__WEBPACK_IMPORTED_MODULE_10__/* ["default"].isReksaDana */ .Z.isReksaDana;
function Header(param) {
    var _symbol = param.symbol, symbol = _symbol === void 0 ? "" : _symbol, company = param.company, _isGuestCompany = param.isGuestCompany, isGuestCompany = _isGuestCompany === void 0 ? false : _isGuestCompany, onClickLink = param.onClickLink, onClickFollow = param.onClickFollow, onClickBuyButton = param.onClickBuyButton, onExpandToggle = param.onExpandToggle;
    var ref;
    var name = company.name, icon_url = company.icon_url, _country = company.country, country = _country === void 0 ? "ID" : _country, _catalogs = company.catalogs, catalogs = _catalogs === void 0 ? [] : _catalogs, exchange = company.exchange, _company_type = company.company_type, company_type = _company_type === void 0 ? "" : _company_type, id = company.id, tradable = company.tradable, tags = company.tags;
    var ref1 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(!!icon_url), isIconAvailable = ref1[0], setIsIconAvailable = ref1[1];
    var ref2 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), isFollowerVisible = ref2[0], setIsFollowerVisible = ref2[1];
    var ref3 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), isFollowCompanyVisible = ref3[0], setIsFollowCompanyVisible = ref3[1];
    var ref4 = (0,react__WEBPACK_IMPORTED_MODULE_9__.useState)(false), isFollowing = ref4[0], setIsFollowing = ref4[1];
    var isTradeable = tradable === 1;
    var POPUP_COUNTRY_FLAG_TEXT = "This stock is traded on ".concat(exchange, " exchange");
    var buttonBuyRef = (0,react__WEBPACK_IMPORTED_MODULE_9__.useRef)(null);
    var router = (0,next_router__WEBPACK_IMPORTED_MODULE_6__.useRouter)();
    var ref5 = (0,_tanstack_react_query__WEBPACK_IMPORTED_MODULE_18__/* .useQuery */ .a)({
        queryKey: [
            "get-company-follower-info",
            symbol,
            isFollowing
        ],
        queryFn: (0,_swc_helpers_src_async_to_generator_mjs__WEBPACK_IMPORTED_MODULE_19__/* ["default"] */ .Z)(_builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().mark(function _callee() {
            var response, data;
            return _builds_stockbitgroup_stockbit_web_web_v3_node_modules_next_dist_compiled_regenerator_runtime_runtime_js__WEBPACK_IMPORTED_MODULE_0___default().wrap(function _callee$(_ctx) {
                while(1)switch(_ctx.prev = _ctx.next){
                    case 0:
                        _ctx.prev = 0;
                        _ctx.next = 3;
                        return lib_api_watchlist__WEBPACK_IMPORTED_MODULE_13__/* ["default"].getCompanyFollowerInfo */ .Z.getCompanyFollowerInfo(symbol);
                    case 3:
                        response = _ctx.sent;
                        if (response.data) {
                            _ctx.next = 6;
                            break;
                        }
                        throw new Error("Something is terribly wrong, please contact our administrator");
                    case 6:
                        data = response.data;
                        if (!(data.data.length === 1)) {
                            _ctx.next = 10;
                            break;
                        }
                        setIsFollowing(data.data[0].is_followed);
                        return _ctx.abrupt("return", data.data[0]);
                    case 10:
                        throw new Error("No Data");
                    case 13:
                        _ctx.prev = 13;
                        _ctx.t0 = _ctx["catch"](0);
                        (0,utils_errors__WEBPACK_IMPORTED_MODULE_20__/* .errorHandler */ .P)(_ctx.t0, "Failed to get detail company chart");
                        return _ctx.abrupt("return", undefined);
                    case 17:
                    case "end":
                        return _ctx.stop();
                }
            }, _callee, null, [
                [
                    0,
                    13
                ]
            ]);
        })),
        retry: false,
        enabled: !isGuestCompany
    }), followerData = ref5.data;
    var ref6 = followerData || {
        total_followers: 0
    }, followers = ref6.total_followers;
    // If not user Day Trade exclude catalog daytrade
    var filteredCatalogs = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(function() {
        return catalogs.filter(function(param) {
            var company_symbol = param.company_symbol;
            return (company_symbol === null || company_symbol === void 0 ? void 0 : company_symbol.toLowerCase()) !== "daytrade";
        });
    }, [
        catalogs
    ]);
    var onImgError = function() {
        setIsIconAvailable(false);
    };
    var formattedCountry = country.toLowerCase();
    var IMAGE_URL = "/img/flags/".concat(formattedCountry, ".png");
    var generateCatalogUrl = function(itemSector, itemSubSector) {
        if (!itemSector) return "";
        return "/catalog/".concat((0,utils_general__WEBPACK_IMPORTED_MODULE_7__/* .convertToSlug */ .k6)(itemSubSector));
    };
    var onClickCatalogsLink = function(event, companySymbol) {
        if (isGuestCompany) {
            event.preventDefault();
            onClickLink(true);
        } else {
            (0,utils_clevertap__WEBPACK_IMPORTED_MODULE_8__/* .clevertapEvent */ .Lq)("Company Action", {
                Action: "emiten_group",
                Group: companySymbol
            });
        }
    };
    var handleSuccessFollow = function(following) {
        setIsFollowing(following);
    };
    var handleToggleFollow = function(following) {
        if (isGuestCompany) {
            onClickFollow();
            return false;
        }
        handleSuccessFollow(following);
        return true;
    };
    var handleOpenModal = (0,react__WEBPACK_IMPORTED_MODULE_9__.useCallback)(function() {
        setIsFollowCompanyVisible(true);
    }, [
        isFollowCompanyVisible
    ]);
    var handleCancelModal = (0,react__WEBPACK_IMPORTED_MODULE_9__.useCallback)(function() {
        setIsFollowCompanyVisible(false);
    }, [
        isFollowCompanyVisible
    ]);
    var handleClickBuyButton = (0,react__WEBPACK_IMPORTED_MODULE_9__.useCallback)(function() {
        var ref;
        buttonBuyRef === null || buttonBuyRef === void 0 ? void 0 : (ref = buttonBuyRef.current) === null || ref === void 0 ? void 0 : ref.click();
    }, [
        buttonBuyRef
    ]);
    (0,react__WEBPACK_IMPORTED_MODULE_9__.useEffect)(function() {
        var ref, ref1;
        if ((router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : (ref1 = ref.param) === null || ref1 === void 0 ? void 0 : ref1[0]) === features_company_constants__WEBPACK_IMPORTED_MODULE_12__/* .TAB_LIST_NAME.BUY */ .p.BUY) {
            handleClickBuyButton();
        }
    }, [
        handleClickBuyButton,
        router === null || router === void 0 ? void 0 : (ref = router.query) === null || ref === void 0 ? void 0 : ref.param
    ]);
    var hasMaturedTags = (0,react__WEBPACK_IMPORTED_MODULE_9__.useMemo)(function() {
        if (tags) {
            return tags === null || tags === void 0 ? void 0 : tags.some(function(tag) {
                var ref;
                return (tag === null || tag === void 0 ? void 0 : (ref = tag.name) === null || ref === void 0 ? void 0 : ref.toLowerCase()) === "matured";
            });
        }
        return false;
    }, [
        tags
    ]);
    var renderCatalogsLink = function(catalogue) {
        var subSectorObject = {
            "Properti & Real Estate": "Properti dan Real Estate",
            Commodities: "Commodity"
        };
        var companySymbol = catalogue.catalog_name || catalogue.company_symbol;
        var companySymbolAlias = subSectorObject[companySymbol] || catalogue.company_symbol;
        var companyType = catalogue.company_type;
        var catalogUrl = "";
        if (companyType === "sub_sector") {
            catalogUrl = generateCatalogUrl(companySymbol, companySymbolAlias);
        } else {
            catalogUrl = "/catalog/".concat(companyType, "/").concat(companySymbolAlias);
        }
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)((next_link__WEBPACK_IMPORTED_MODULE_5___default()), {
            href: catalogUrl,
            passHref: true,
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CatalogButton */ .WW, {
                target: "_blank",
                rel: "noopener noreferrer",
                onClick: function(e) {
                    return onClickCatalogsLink(e, companySymbol);
                },
                children: companySymbol
            })
        });
    };
    var renderSymbol = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .Symbol */ .mN, {
            children: cleanSymbol(symbol.toUpperCase())
        });
    };
    var renderCountryFlag = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CountryFlagContainer */ .Hr, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(antd__WEBPACK_IMPORTED_MODULE_21__/* ["default"] */ .Z, {
                className: "desktop",
                placement: "top",
                title: POPUP_COUNTRY_FLAG_TEXT,
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CountryFlag */ .AW, {
                    src: IMAGE_URL,
                    alt: "".concat(country, " flag")
                }, "country-flag-desktop")
            })
        });
    };
    var renderCountryFlagMobile = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CountryFlagContainerMobile */ .vo, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CountryFlag */ .AW, {
                className: "mobile",
                src: IMAGE_URL,
                alt: "".concat(country, " flag")
            }, "country-flag-mobile")
        });
    };
    var renderButtons = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ButtonContainer */ .qO, {
            children: [
                !isGuestCompany && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_17__/* .FollowerText */ .Bs, {
                            as: "span",
                            onClick: function() {
                                return setIsFollowerVisible(true);
                            },
                            children: [
                                numeral__WEBPACK_IMPORTED_MODULE_4___default()(followers).format("0,0"),
                                " followers"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_FollowCompanyButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            isFollowed: isFollowing,
                            onClick: handleOpenModal
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    condition: isTradeable && !isReksaDana(company_type) && !hasMaturedTags,
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ButtonBuy */ .JQ, {
                        "data-cy": "company-buy-button",
                        onClick: onClickBuyButton,
                        ref: buttonBuyRef,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            weight: "bolder",
                            align: "center",
                            color: "inherit",
                            children: "Buy"
                        })
                    })
                })
            ]
        });
    };
    var renderButtonsMobile = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ButtonContainerMobile */ .Y8, {
            children: [
                !isGuestCompany && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_styled__WEBPACK_IMPORTED_MODULE_17__/* .FollowerText */ .Bs, {
                            as: "span",
                            onClick: function() {
                                return setIsFollowerVisible(true);
                            },
                            children: [
                                numeral__WEBPACK_IMPORTED_MODULE_4___default()(followers).format("0,0"),
                                " followers"
                            ]
                        }),
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_FollowCompanyButton__WEBPACK_IMPORTED_MODULE_16__/* ["default"] */ .Z, {
                            isFollowed: isFollowing,
                            onClick: handleOpenModal
                        })
                    ]
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_ErrorHandlers_If__WEBPACK_IMPORTED_MODULE_22__/* ["default"] */ .Z, {
                    condition: isTradeable && !isReksaDana(company_type),
                    children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ButtonBuy */ .JQ, {
                        onClick: onClickBuyButton,
                        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z, {
                            weight: "bolder",
                            align: "center",
                            color: "inherit",
                            children: "Buy"
                        })
                    })
                })
            ]
        });
    };
    var renderCompanyLogo = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ImageWrapper */ .fb, {
            align: "center",
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z, {
                    align: "center",
                    children: [
                        isIconAvailable ? /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Image__WEBPACK_IMPORTED_MODULE_14__/* ["default"] */ .Z, {
                            className: "company-header-icon",
                            src: icon_url,
                            onError: onImgError,
                            alt: symbol,
                            width: "54px",
                            height: "54px"
                        }) : /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ImagePlaceholder */ .Zc, {
                            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("small", {
                                children: !!symbol && symbol.toUpperCase().slice(0, 1)
                            })
                        }),
                        !!country && renderCountryFlagMobile()
                    ]
                }),
                renderButtonsMobile()
            ]
        });
    };
    var renderMaturedBadges = function() {
        return tags.map(function(item) {
            return item.name === "MATURED" && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .Badges */ .a9, {
                children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    children: item.name
                })
            }, item.name);
        });
    };
    var renderCompanyName = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CompanyName */ .zo, {
            children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("h1", {
                children: name
            })
        });
    };
    var renderCompanyTags = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CompanyTags */ .cr, {
            children: filteredCatalogs.slice(0, 6).map(function(catalogue) {
                return catalogue.show && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)("span", {
                    className: "catalogs",
                    children: renderCatalogsLink(catalogue)
                }, catalogue.company_symbol);
            })
        });
    };
    var renderExpandButtonToggle = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ExpandButtonToggleMobile */ .U7, {
            onExpand: onExpandToggle
        });
    };
    var renderFollowerModal = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(global_Moderation_Modals__WEBPACK_IMPORTED_MODULE_11__/* .ModalFollower */ .ZZ, {
            symbol: symbol,
            companyId: id,
            visible: isFollowerVisible,
            onCancel: function() {
                return setIsFollowerVisible(false);
            }
        });
    };
    var renderFollowModal = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsx)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .ModalFollowing */ .Mw, {
            visible: isFollowCompanyVisible,
            onCancel: handleCancelModal,
            companyId: id,
            onFollow: handleToggleFollow
        });
    };
    var renderCompanyHeader = function() {
        return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CompanyHeader */ .ag, {
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CompanyIdentity */ .GT, {
                    children: [
                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CompanyInfoWrapper */ .n4, {
                            $isIconAvailable: isIconAvailable,
                            children: [
                                renderCompanyLogo(),
                                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .CompanyNameContainer */ .Yu, {
                                    children: [
                                        renderSymbol(),
                                        /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(_Header_styled__WEBPACK_IMPORTED_MODULE_15__/* .NotationCountryFlagContainer */ .gv, {
                                            children: [
                                                !!country && renderCountryFlag(),
                                                renderMaturedBadges()
                                            ]
                                        }),
                                        renderCompanyName(),
                                        renderCompanyTags()
                                    ]
                                }),
                                renderExpandButtonToggle()
                            ]
                        }),
                        renderButtons()
                    ]
                }),
                !isGuestCompany && /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.jsxs)(react_jsx_runtime__WEBPACK_IMPORTED_MODULE_1__.Fragment, {
                    children: [
                        renderFollowerModal(),
                        renderFollowModal()
                    ]
                })
            ]
        });
    };
    return renderCompanyHeader();
}
/* harmony default export */ __webpack_exports__["Z"] = (Header);


/***/ }),

/***/ 47513:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {


// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ Hero_MainChart; }
});

// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/features/company/Chart/styled.ts
var styled = __webpack_require__(33263);
// EXTERNAL MODULE: ./node_modules/next/link.js
var next_link = __webpack_require__(41664);
var link_default = /*#__PURE__*/__webpack_require__.n(next_link);
// EXTERNAL MODULE: ./src/features/company/Chart/EmptyChart.tsx + 1 modules
var EmptyChart = __webpack_require__(19970);
// EXTERNAL MODULE: ./node_modules/react-chartjs-2/dist/index.modern.js + 1 modules
var index_modern = __webpack_require__(508);
// EXTERNAL MODULE: ./node_modules/moment/moment.js
var moment = __webpack_require__(30381);
var moment_default = /*#__PURE__*/__webpack_require__.n(moment);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/@deprecated-ui/_style/color.js
var color = __webpack_require__(22147);
;// CONCATENATED MODULE: ./src/features/company/FRPage/Hero/CompanyChart.tsx





var fillColor = color/* default.clearDay */.Z.clearDay;
var lineColor = color/* default.mountainMeadow */.Z.mountainMeadow;
function CompanyChart(param) {
    var chart = param.chart, _timeframe = param.timeframe, timeframe = _timeframe === void 0 ? "1d" : _timeframe, _chartType = param.chartType, chartType = _chartType === void 0 ? "yield" : _chartType, onClickChart = param.onClickChart;
    var prices = chart.chart_points;
    var createPreviousMonth = function(numberOfMonth) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfMonth, "month");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "months") <= 0){
            data.push(dateStart.format("MMM YYYY"));
            dateStart.add(1, "month");
        }
        return data;
    };
    var createPreviousYear = function(numberOfYear) {
        var data = [];
        var dateStart = moment_default()().subtract(numberOfYear, "y");
        var dateEnd = moment_default()();
        while(dateStart.diff(dateEnd, "years") <= 0){
            data.push(dateStart.format("YYYY"));
            dateStart.add(1, "year");
        }
        return data;
    };
    var ref = (0,react.useMemo)(function() {
        if (timeframe === "1m") return [
            "DD MMM",
            5,
            []
        ];
        if (timeframe === "3m") {
            var previousMonths = createPreviousMonth(2);
            return [
                "MMM",
                3,
                previousMonths
            ];
        }
        if (timeframe === "ytd") return [
            "DD MMM",
            5
        ];
        if (timeframe === "1y") {
            var previousMonths1 = createPreviousMonth(11);
            return [
                "MMM",
                12,
                previousMonths1,
                false
            ];
        }
        if (timeframe === "3y") {
            var previousYear = createPreviousYear(2);
            return [
                "YYYY",
                3,
                previousYear
            ];
        }
        if (timeframe === "5y") {
            var previousYear1 = createPreviousYear(4);
            return [
                "YYYY",
                5,
                previousYear1
            ];
        }
        if (timeframe === "all") {
            var previousYear2 = createPreviousYear(4);
            return [
                "YYYY",
                5,
                previousYear2
            ];
        }
        return [
            "HH:mm",
            6,
            []
        ];
    }, [
        timeframe
    ]), format = ref[0], maxTicks = ref[1], labels = ref[2], tmp = ref[3], autoSkip = tmp === void 0 ? true : tmp;
    var chartData = (0,react.useMemo)(function() {
        return {
            labels: prices.map(function(price) {
                if (!price.formated_date && price.date === "0") return "";
                var formattedDate = moment_default()(price.formated_date);
                var monthYear = formattedDate.format("MMM YYYY");
                var month = formattedDate.format("MMM");
                var year = formattedDate.format("YYYY");
                var formattedByTimeframe = formattedDate.format(format);
                switch(timeframe){
                    case "1m":
                    case "1d":
                        return formattedDate.minute() === 0 ? formattedByTimeframe : "";
                    case "3m":
                    case "1y":
                        if (labels.includes(monthYear)) {
                            labels.splice(labels.indexOf(monthYear), 1);
                            return month;
                        }
                        return "";
                    case "3y":
                    case "5y":
                    case "all":
                        if (labels.includes(year)) {
                            labels.splice(labels.indexOf(year), 1);
                            return year;
                        }
                        return "";
                    default:
                        return moment_default()(price.formated_date).format(format);
                }
            }),
            datasets: [
                {
                    fill: true,
                    tension: 0,
                    backgroundColor: fillColor,
                    borderColor: lineColor,
                    borderCapStyle: "butt",
                    borderDashOffset: 0.0,
                    borderJoinStyle: "round",
                    borderWidth: 2,
                    data: prices.map(function(pr) {
                        var number = pr.values.find(function(val) {
                            return val.key === chartType;
                        }).value;
                        var parsedNumber = parseFloat(number);
                        return parseFloat(parsedNumber.toFixed(2));
                    })
                }, 
            ]
        };
    }, [
        prices,
        format,
        chartType
    ]);
    var options = (0,react.useMemo)(function() {
        return {
            animation: {
                duration: 0
            },
            resizeDelay: 0,
            plugins: {
                legend: {
                    display: false
                },
                tooltip: {
                    enabled: false
                }
            },
            maintainAspectRatio: false,
            scales: {
                y: {
                    position: "right",
                    grid: {
                        display: false,
                        drawBorder: false
                    },
                    ticks: {
                        maxTicksLimit: 8,
                        callback: function callback(val) {
                            var parsedNumber = parseFloat("".concat(val));
                            return "".concat(parsedNumber.toFixed(2), "%");
                        }
                    }
                },
                x: {
                    grid: {
                        display: false
                    },
                    ticks: {
                        align: "start",
                        maxTicksLimit: maxTicks,
                        maxRotation: 0,
                        callback: function callback(val) {
                            // eslint-disable-next-line react/no-this-in-sfc
                            return this.getLabelForValue(val) || null;
                        },
                        autoSkip: autoSkip,
                        precision: 0
                    }
                }
            },
            elements: {
                point: {
                    radius: 0
                }
            },
            events: [
                "click"
            ],
            onClick: onClickChart
        };
    }, [
        maxTicks,
        onClickChart
    ]);
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(index_modern/* Line */.x1, {
        data: chartData,
        options: options,
        height: 300
    });
}
/* harmony default export */ var Hero_CompanyChart = (CompanyChart);

;// CONCATENATED MODULE: ./src/features/company/FRPage/Hero/MainChart.tsx





var MainChart = function(param) {
    var visible = param.visible, symbol = param.symbol, chart = param.chart, timeframe = param.timeframe, chartType = param.chartType, disableChartbitLink = param.disableChartbitLink, isLoadingChart = param.isLoadingChart, onClickChart = param.onClickChart;
    if (!visible) return null;
    return /*#__PURE__*/ (0,jsx_runtime.jsxs)(styled/* MainChartContent */.LH, {
        children: [
            chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(styled/* ChartContainer */.BO, {
                children: disableChartbitLink ? /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_CompanyChart, {
                    chart: chart,
                    chartType: chartType,
                    timeframe: timeframe,
                    onClickChart: onClickChart
                }) : /*#__PURE__*/ (0,jsx_runtime.jsx)((link_default()), {
                    href: "/symbol/".concat(symbol, "/chartbit"),
                    passHref: true,
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)("a", {
                        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Hero_CompanyChart, {
                            chart: chart,
                            chartType: chartType,
                            timeframe: timeframe,
                            onClickChart: onClickChart
                        })
                    })
                })
            }),
            !isLoadingChart && !chart && /*#__PURE__*/ (0,jsx_runtime.jsx)(EmptyChart/* default */.Z, {})
        ]
    });
};
/* harmony default export */ var Hero_MainChart = (MainChart);


/***/ }),

/***/ 81676:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Bs": function() { return /* binding */ FollowerText; },
/* harmony export */   "dI": function() { return /* binding */ HeroWrapper; },
/* harmony export */   "hC": function() { return /* binding */ ChartWrapper; },
/* harmony export */   "nJ": function() { return /* binding */ ChartSectionItem; }
/* harmony export */ });
/* unused harmony exports CustomIconmoon, ChartSectionItemContainer */
/* harmony import */ var _swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(7297);
/* harmony import */ var _deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(95541);
/* harmony import */ var _deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(70821);
/* harmony import */ var _deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(15807);
/* harmony import */ var _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(74575);
/* harmony import */ var _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(22147);
/* harmony import */ var styled_components__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(19521);

function _templateObject() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  line-height: 1;\n  font-size: 14px;\n\n  &.icon-symbol_up:before {\n    content: '\\25B2';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 2px;\n    padding-left: 2px;\n  }\n  &.icon-symbol_down:before {\n    content: '\\25BC';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 2px;\n    padding-left: 2px;\n  }\n"
    ], [
        "\n  line-height: 1;\n  font-size: 14px;\n\n  &.icon-symbol_up:before {\n    content: '\\\\25B2';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 2px;\n    padding-left: 2px;\n  }\n  &.icon-symbol_down:before {\n    content: '\\\\25BC';\n    display: inline-block;\n    font-size: 12px;\n    padding-bottom: 2px;\n    padding-left: 2px;\n  }\n"
    ]);
    _templateObject = function _templateObject() {
        return data;
    };
    return data;
}
function _templateObject1() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  background: #FFFFFF;\n  padding: 20px;\n"
    ]);
    _templateObject1 = function _templateObject1() {
        return data;
    };
    return data;
}
function _templateObject2() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  border: 1px solid #DADADA;\n  border-radius: 4px;\n  margin-bottom: 32px;\n"
    ]);
    _templateObject2 = function _templateObject2() {
        return data;
    };
    return data;
}
function _templateObject3() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  gap: 20px;\n"
    ]);
    _templateObject3 = function _templateObject3() {
        return data;
    };
    return data;
}
function _templateObject4() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    padding-right: 20px;\n    display: block;\n    border-right: 1px solid #EDEDED;\n\n    :last-child {\n      border-right: unset;\n    }\n  }\n"
    ]);
    _templateObject4 = function _templateObject4() {
        return data;
    };
    return data;
}
function _templateObject5() {
    var data = (0,_swc_helpers_src_tagged_template_literal_mjs__WEBPACK_IMPORTED_MODULE_0__/* ["default"] */ .Z)([
        "\n  display: none;\n\n  @media ",
        " {\n    cursor: pointer;\n    display: block;\n    margin-right: 10px;\n\n    :hover {\n      color: ",
        ";\n    }\n  }\n"
    ]);
    _templateObject5 = function _templateObject5() {
        return data;
    };
    return data;
}






var CustomIconmoon = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Iconmoon__WEBPACK_IMPORTED_MODULE_3__/* ["default"] */ .Z).withConfig({
    componentId: "sc-96aaaa00-0"
})(_templateObject());
var ChartWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96aaaa00-1"
})(_templateObject1());
var HeroWrapper = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96aaaa00-2"
})(_templateObject2());
var ChartSectionItemContainer = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Flex__WEBPACK_IMPORTED_MODULE_2__/* ["default"] */ .Z).withConfig({
    componentId: "sc-96aaaa00-3"
})(_templateObject3());
var ChartSectionItem = styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"].div.withConfig */ .ZP.div.withConfig({
    componentId: "sc-96aaaa00-4"
})(_templateObject4(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet);
var FollowerText = (0,styled_components__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .ZP)(_deprecated_ui_common_Text__WEBPACK_IMPORTED_MODULE_1__/* ["default"] */ .Z).attrs({
    color: "#969696",
    size: "12px"
}).withConfig({
    componentId: "sc-96aaaa00-5"
})(_templateObject5(), _deprecated_ui_style_device__WEBPACK_IMPORTED_MODULE_4__/* ["default"].tablet */ .Z.tablet, _deprecated_ui_style_color__WEBPACK_IMPORTED_MODULE_5__/* ["default"].midgray */ .Z.midgray);


/***/ })

}]);